import { useMemo } from 'react';

import { useFrontendConfiguration } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

import { RoverStatsigUser } from '../types';

export function useRoverStatsigUser(): {
  roverStatsigUser: RoverStatsigUser;
  isLoading: boolean;
  error: Error | null;
} {
  const { settings: frontendConfigSettings, isLoading, error } = useFrontendConfiguration();
  const experimentUserAttributes = frontendConfigSettings?.experimentUserAttributes;

  const roverStatsigUser: RoverStatsigUser = useMemo(() => {
    if (!experimentUserAttributes) return {};
    return {
      userID: experimentUserAttributes.userId ?? undefined,
      email: experimentUserAttributes.email ?? undefined,
      country: experimentUserAttributes.country ?? undefined,
      ip: experimentUserAttributes.ip ?? undefined,
      userAgent: experimentUserAttributes.userAgent ?? undefined,
      appVersion: experimentUserAttributes.appVersion ?? undefined,
      locale: experimentUserAttributes.locale ?? undefined,
      custom: {
        ...experimentUserAttributes.custom,
      },
      customIDs: {
        roverCID: experimentUserAttributes.customIds?.roverCid,
        environmentID: experimentUserAttributes.customIds?.environmentId,
      },
    };
  }, [experimentUserAttributes]);

  return { roverStatsigUser, isLoading, error };
}
